"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThemesWithRestoredColors = void 0;
var _1 = require(".");
var updateThemeValues = function (node) {
    var _a;
    if (!node || typeof node !== 'object') {
        return node;
    }
    if (node.value) {
        return (0, _1.getRestoredColorFromPalette)(node.value) || node.value;
    }
    for (var _i = 0, _b = Object.entries(node); _i < _b.length; _i++) {
        var _c = _b[_i], key = _c[0], newNode = _c[1];
        var newValue = updateThemeValues(newNode);
        if ((_a = node[key]) === null || _a === void 0 ? void 0 : _a.value) {
            node[key].value = newValue;
        }
    }
    return node;
};
var getThemesWithRestoredColors = function (node) {
    var deepClone = JSON.parse(JSON.stringify(node));
    return updateThemeValues(deepClone);
};
exports.getThemesWithRestoredColors = getThemesWithRestoredColors;
//# sourceMappingURL=getThemesWithRestoredColors.js.map